import React, { useState } from "react";
import { TextInput, Menu } from "@mantine/core";
import SearchIcon from "@mui/icons-material/Search";

import US from "../../assets/flags/us.png";
import BE from "../../assets/flags/be.png";
import NL from "../../assets/flags/nl.png";

import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { colors, sizes } from "../../configs";
import { Box } from "@mui/material";
const langs = [
  {
    title: "Français(BE)",
    code: "be_fr",
    flag: BE,
  },
  {
    title: "Flamand(BE)",
    code: "be_nl",
    flag: NL,
  },
  {
    title: "English",
    code: "us",
    flag: US,
  },
];
type Props = {
  onChoiceDone: (choice: any) => void;
};
const LanguagesMenu = ({ onChoiceDone }: Props) => {
  const [selLanguage, setSelLanguage] = useState<any | null>({
    title: "English",
    code: "us",
    flag: US,
  });
  const onChoice = (choice: any) => {
    console.log("====================================");
    console.log(choice);
    console.log("====================================");
    setSelLanguage(choice);
    onChoiceDone(choice);
  };
  return (
    <div>
      <Menu.Dropdown
        id="languageDrop"
        sx={{
          padding: "15px 15px",
          borderRadius: sizes.radius,
        }}>
        <TextInput
          variant="filled"
          placeholder="Search a language"
          size="sm"
          icon={<SearchIcon />}
          style={{
            border: "none",
            borderColor: " transparent",
            borderRadius: "50%",
          }}
          mb="sm"
        />
        <div
          style={{
            maxWidth: sizes.dropDownWidth,
            maxHeight: sizes.dropDownHeight,
            overflowY: "auto",
          }}>
          {langs.map((ln, idx) => (
            <Menu.Item
              key={idx}
              component="a"
              href="#"
              onClick={() => onChoice(ln)}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}>
                <img
                  src={ln.flag}
                  style={{
                    flex: 0.5,
                    display: "inline",
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginRight: "10px",
                  }}
                />

                <Typography
                  variant="body2"
                  component="code"
                  style={{
                    flex: 3,

                    fontWeight:
                      selLanguage.code === ln.code ? "bolder" : "lighter",
                    fontSize: sizes.dropDownItemSize,
                  }}>
                  {ln.title}
                </Typography>
                {selLanguage.code === ln.code && (
                  <CheckCircleIcon
                    sx={{
                      flex: 1,

                      color: colors.main,
                    }}
                  />
                )}
              </Box>
            </Menu.Item>
          ))}
        </div>
      </Menu.Dropdown>
    </div>
  );
};

export default LanguagesMenu;
